
function ensureGoogleRecaptcha() {
    if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
    if (window.__recaptchaLoader) return window.__recaptchaLoader;

    window.__recaptchaLoader = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
        script.async = true;
        script.onload = function () {
            var start = Date.now();
            (function waitForGrecaptcha() {
                if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
                    resolve(window.grecaptcha);
                    return;
                }
                if (Date.now() - start > 8000) {
                    reject(new Error('reCAPTCHA failed to load'));
                    return;
                }
                requestAnimationFrame(waitForGrecaptcha);
            })();
        };
        script.onerror = function () {
            window.__recaptchaLoader = null;
            reject(new Error('reCAPTCHA script error'));
        };
        document.head.appendChild(script);
    });

    return window.__recaptchaLoader;
}

function renderRecaptchaWidgets(root) {
    var scope = root || document;
    var widgets = scope.querySelectorAll('.g-recaptcha');
    if (!widgets.length) return;

    ensureGoogleRecaptcha()
        .then(function (grecaptcha) {
            widgets.forEach(function (el) {
                if (el.dataset.recaptchaRendered === 'true') return;
                if (!el.dataset.sitekey) return;
                try {
                    grecaptcha.render(el, { sitekey: el.dataset.sitekey });
                    el.dataset.recaptchaRendered = 'true';
                } catch (err) {
                    // Already rendered or API not ready — ignore
                }
            });
        })
        .catch(function () { });
}

function OpenAnyMainModal(className) {
    if (!className) return;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const mainModal = document.querySelector(className);
    if (!mainModal) return;
    mainModal.style.display = 'flex';
    mainModal.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
    if (isMobile) {
        DisplayZohopopupButton(false);
        setTimeout(() => {
            mainModal.querySelector('.main-modal-content').style.transform = 'translateY(0)';
        }, 10);
    } else {
        mainModal.querySelector('.main-modal-content').style.transform = 'translateY(0)';
        setTimeout(() => {
            mainModal.style.opacity = '1';
        }, 10);
    }

    // Load + render captcha only when a modal that needs it opens
    if (mainModal.querySelector('.g-recaptcha')) {
        renderRecaptchaWidgets(mainModal);
    }
}

function CloseAnyMainModal(className, event, isCloseButton = false) {
    if (isCloseButton || event.target == event.currentTarget) {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const mainModal = document.querySelector(className);
        if (!mainModal) return;
        mainModal.querySelectorAll('iframe[src*="youtube.com"]').forEach((iframe) => {
            if (iframe.contentWindow) {
                iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }
        });
        mainModal.style.backgroundColor = 'rgba(0, 0, 0, 0)';
        DisplayZohopopupButton(true);
        if (isMobile) {
            mainModal.querySelector('.main-modal-content').style.transform = 'translateY(100%)';
        } else {
            mainModal.style.opacity = '0';
        }
        setTimeout(() => {
            mainModal.style.display = 'none';
            mainModal.querySelector('.main-modal-content').style.transform = 'translateY(100%)';
        }, 300);
    }
}

function DisplayZohopopupButton(show = false) {
    const zohopopup = document.querySelector('.zsiq_floatmain.zsiq_theme11.siq_bR');
    if (!zohopopup) return;
    zohopopup.style.display = show ? 'block' : 'none';
}

function getCollectionFromSKU(skuCode) {
    if (!skuCode) return 'Jewellery';
    if (skuCode.includes('RMR')) {
        return 'Recently Made Ring';
    } else if (skuCode.includes('ER')) {
        return 'Exclusive Engagement Ring';
    } else if (skuCode.includes('WB') || skuCode.includes('RE0')) {
        return 'Wedding Ring';
    } else {
        return 'Jewellery';
    }
}

function getCookie(name) {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] ?? '';
}

const MODAL_FORM_REDIRECT_PATH = '/pages/form-submission-success';

const MODAL_FORM_CONFIG = {
    'product-discount': {
        tagAction: 'check_discount_form_submit',
        productLabel: 'Product Code',
        buildName(formData) {
            const collection = getCollectionFromSKU(formData.get('product'));
            return `My name is ${formData.get('username')} and I am interested in this ${collection}`;
        },
        buildSubject(formData) {
            return `${getCollectionFromSKU(formData.get('product'))}: Discount Request`;
        },
        appendExtraFields(formData) {
            const engravingText = document.getElementById('ProductEngraving')?.value;
            const sizingRegion = document.getElementById('RingSizeCountry')?.value;
            const sizingGuideValue = document.querySelector('.product-option__select.active')?.value;
            const chosenRingColor = document.querySelector('input[name="properties[Metal]"]')?.value;

            if (engravingText) formData.append('engraving_text', engravingText);
            if (sizingRegion) formData.append('sizing_region', sizingRegion);
            if (sizingGuideValue) formData.append('sizing_guide', sizingGuideValue);
            if (chosenRingColor) formData.append('chosen_ring_color', chosenRingColor);
        },
    },
    'product-request-price': {
        tagAction: 'request_price_form_submit',
        productLabel: 'Product Code',
        buildName(formData) {
            const collection = getCollectionFromSKU(formData.get('product'));
            return `My name is ${formData.get('username')} and I would like the price of this ${collection}`;
        },
        buildSubject(formData) {
            return `${getCollectionFromSKU(formData.get('product'))}: Request for Price`;
        },
        appendExtraFields(formData) {
            const engravingText = document.getElementById('ProductEngraving')?.value;
            const sizingRegion = document.getElementById('RingSizeCountry')?.value;
            const sizingGuideValue = document.querySelector('.product-option__select.active')?.value;
            const chosenRingColor = document.querySelector('input[name="properties[Metal]"]')?.value;

            if (engravingText) formData.append('engraving_text', engravingText);
            if (sizingRegion) formData.append('sizing_region', sizingRegion);
            if (sizingGuideValue) formData.append('sizing_guide', sizingGuideValue);
            if (chosenRingColor) formData.append('chosen_ring_color', chosenRingColor);
        },
    },
    'rb-contact-us': {
        tagAction: 'contact_us_form_submit',
        productLabel: 'Product Summary',
        buildName(formData) {
            const enquiryCategory = (formData.get('enquiry-category') || 'an enquiry').toLowerCase();
            return `My name is ${formData.get('username')} and I am contacting you from ring builder page about ${enquiryCategory}`;
        },
        buildSubject() {
            return "Ring Builder Contact Us";
        },
    },
    'rb-diamond-discount': {
        tagAction: 'check_diamond_discount_form_submit',
        productLabel: 'Product Title',
        buildName(formData) {
            return `My name is ${formData.get('username')} and I'd like to check for discount`;
        },
        buildSubject() {
            return 'Ring Builder Discount Request';
        },
    },
    'contact-page': {
        tagAction: 'contact_us_form_submit',
        productLabel: 'Category',
        buildName(formData) {
            return `My name is ${formData.get('username')} and I am contacting you from contact us page`;
        },
        buildSubject() {
            return 'Contact us';
        },
    },
    'cro-contact': {
        tagAction: 'contact_us_form_submit',
        productLabel: 'Page URL',
        buildName(formData) {
            return `My name is ${formData.get('username')} and I am contacting you from cro page`;
        },
        buildSubject() {
            return 'CRO Contact Us';
        },
    },
    'cart-deposit': {
        tagAction: 'deposit_request_form_submit',
        productLabel: 'Cart items',
        buildName(formData) {
            return `My name is ${formData.get('username')} and I'd like to confirm my order with 20% deposit`;
        },
        buildSubject() {
            return 'Deposit Request';
        },
    },
};

async function submitModalForm(event) {
    event.preventDefault();

    const contactForm = event.target;
    const formType = contactForm.dataset.modalForm;
    const config = MODAL_FORM_CONFIG[formType];

    if (!config) {
        console.error('Unknown modal form type:', formType);
        return;
    }

    const submitButton = contactForm.querySelector('button[type="submit"]');
    submitButton.disabled = true;


    try {
        const formData = new FormData(contactForm);
        formData.append('wc_client_current', getCookie('wc_client_current') || 'null');

        const recaptchaToken =
            formData.get('g-recaptcha-response') ||
            contactForm.querySelector('[name="g-recaptcha-response"]')?.value ||
            (window.grecaptcha ? window.grecaptcha.getResponse() : '');

        formData.set('g-recaptcha-response', recaptchaToken);

        const firstName = formData.get('username');
        const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        if (digits.some((digit) => firstName?.includes(digit))) {
            throw new Error('First Name cannot contain numbers');
        }

        formData.append('number', '+' + formData.get('whatsapp_number'));
        formData.append('name', config.buildName(formData));
        formData.append('subject', config.buildSubject(formData));
        formData.set('product_label', config.productLabel);
        formData.append('product_url', window.location.href);

        if (config.appendExtraFields) {
            config.appendExtraFields(formData);
        }

        const response = await fetch('https://rmrmailer.vercel.app/api', {
            method: 'POST',
            body: new URLSearchParams(formData),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then((res) => res.json());

        if (response.status === 'valid') {
            let tagParams = 'success=true';
            try {
                tagParams = seoTagPageUrlParams(config.tagAction, formData);
            } catch (error) {
                console.error(error);
            }

            contactForm.classList.add('valid');
            contactForm.classList.remove('invalid');

            const errorBox = contactForm.querySelector('.modal-form-error-message');
            const successBox = contactForm.querySelector('.modal-form-success-message');
            if (errorBox) errorBox.style.display = 'none';
            if (successBox) successBox.style.display = 'flex';

            const currentUrl = window.location.pathname;
            window.location.href = `${MODAL_FORM_REDIRECT_PATH}?src=${currentUrl}&${tagParams}`;
            return;
        }

        throw new Error(response.error || 'Invalid form data');
    } catch (error) {
        console.error(error);
        contactForm.classList.add('invalid');
        contactForm.classList.remove('valid');
        const errorBox = contactForm.querySelector('.modal-form-error-message');
        if (errorBox && error.message !== 'Invalid form data') {
            errorBox.style.display = 'flex';
            const errorText = errorBox.querySelector('p');
            if (errorText) errorText.textContent = error.message;
        }
        submitButton.disabled = false;
    }
}

// Page-level captchas (contact form, etc.) — load when visible, not on every storefront page
document.addEventListener('DOMContentLoaded', function () {
    var pageWidgets = document.querySelectorAll('.g-recaptcha');
    if (!pageWidgets.length) return;

    pageWidgets.forEach(function (el) {
        // Skip widgets parked inside closed modals; those load on OpenAnyMainModal
        if (el.closest('.main-modal-content, .main-modal, [class*="modal_"]')) {
            var modalRoot = el.closest('[class*="modal"]');
            if (modalRoot && getComputedStyle(modalRoot).display === 'none') return;
        }
        renderRecaptchaWidgets(el.parentElement);
    });
});
